import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

// Skeleton de carga de la tabla, como CandidateApplicationsListTable de Velora: las celdas
// se pintan dentro de la tabla real para que anchos, paddings y alturas coincidan con las
// filas de datos y no haya saltos de layout al llegar los datos.
export const SKELETON_ROW_FLAG = '__skeleton'

const MAX_SKELETON_ROWS = 20

const pill = <Skeleton variant="rect" animation="wave" width={80} height={24} style={{ borderRadius: 12, margin: '0 auto' }} />
const line = width => <Skeleton variant="rect" animation="wave" width={width} height={14} style={{ borderRadius: 4, margin: '0 auto' }} />

const avatarName = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <Skeleton variant="circle" animation="wave" width={40} height={40} style={{ flexShrink: 0 }} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <Skeleton variant="rect" animation="wave" width={150} height={14} style={{ borderRadius: 4 }} />
        <Skeleton variant="rect" animation="wave" width={90} height={12} style={{ borderRadius: 4 }} />
      </div>
    </div>
)

const SKELETON_CELLS_BY_FIELD = {
  'person.nombre': avatarName,
  search_candidature_name: (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <Skeleton variant="circle" animation="wave" width={40} height={40} style={{ flexShrink: 0 }} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <Skeleton variant="rect" animation="wave" width={150} height={14} style={{ borderRadius: 4 }} />
        <Skeleton variant="rect" animation="wave" width={90} height={12} style={{ borderRadius: 4 }} />
      </div>
    </div>
  ),
  is_favorite: <Skeleton variant="circle" animation="wave" width={24} height={24} />,
  job_offer_application_favs: <Skeleton variant="circle" animation="wave" width={24} height={24} />,
  'selection_status.phase': pill,
  'selection_status.name': pill,
  selection_status: pill,
  selection_phase: pill,
  estado: pill,
  'state.id': pill,
  profile: line(80),
  skills: line(80),
  matching: <Skeleton variant="circle" animation="wave" width={54} height={54} style={{ margin: '0 auto' }} />,
  video: <Skeleton variant="rect" animation="wave" width={24} height={24} style={{ borderRadius: 4, margin: '0 auto' }} />,
  cv: <Skeleton variant="rect" animation="wave" width={24} height={24} style={{ borderRadius: 4, margin: '0 auto' }} />,
  tags: <Skeleton variant="rect" animation="wave" width={100} height={24} style={{ borderRadius: 12 }} />
}

export const renderSkeletonCell = field => SKELETON_CELLS_BY_FIELD[field] || line(70)

export const isSkeletonRow = rowData => !!(rowData && rowData[SKELETON_ROW_FLAG])

export const buildSkeletonRows = pageSize =>
  Array.from({ length: Math.min(pageSize || MAX_SKELETON_ROWS, MAX_SKELETON_ROWS) }, (_, index) => ({
    id: `skeleton-${index}`,
    [SKELETON_ROW_FLAG]: true
  }))

// Para tablas con columnas propias (jobs, candidaturas de un job): en las filas de skeleton
// cada columna pinta su skeleton en lugar de su render
export const withSkeletonRender = columns => columns.map(column => {
  const render = column.render
  const wrapped = rowData => (isSkeletonRow(rowData)
    ? renderSkeletonCell(column.field)
    : render ? render(rowData) : rowData[column.field])
  if (render && render.displayName) wrapped.displayName = render.displayName
  return { ...column, render: wrapped }
})
